module.exports = __webpack_public_path__ + "static/media/guard.0b029627.png";